/* eslint-disable class-methods-use-this */
var ezdia;
(function (ezdia) {
    var ConsumerDataPrivacyObj = /** @class */ (function () {
        function ConsumerDataPrivacyObj() {
            this.orderDetails = [];
        }
        ConsumerDataPrivacyObj.prototype.load = function () {
            this.sendMail();
        };
        ConsumerDataPrivacyObj.prototype.sendMail = function () {
            $('#consumerDataPrivacy').on('submit', function onsubmit(event) {
                event.preventDefault();
                var $form = $(this);
                var url = $form.attr('action');
                if (!$form.valid()) {
                    return;
                }
                $.ajax({
                    url: url,
                    data: $('#consumerDataPrivacy').serialize(),
                    dataType: 'json',
                    success: function (response) {
                        if (response.success === 'true') {
                            var wrapper = ezdia.util.getWrapper('ez-confirm-mail');
                            wrapper.html($('#successMessage').html()).dialog({
                                modal: true,
                                title: 'Status',
                                width: 600,
                                height: 'auto',
                                buttons: [
                                    {
                                        text: 'Close',
                                        class: 'btn-link',
                                        click: function () {
                                            $(this).dialog('close');
                                        }
                                    }
                                ]
                            });
                            var validator = $('#consumerDataPrivacy').validate();
                            validator.resetForm();
                        }
                    }
                });
            });
        };
        return ConsumerDataPrivacyObj;
    }());
    var pages;
    (function (pages) {
        pages.consumerDataPrivacy = new ConsumerDataPrivacyObj();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
